import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

function Countries() {
  const [aggregates, setAggregates] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/hdp/workspace/aggregates')
      .then((res) => setAggregates(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="main-body entity-workspace">
      <div className="hdp-section-head">
        <div>
          <h1 className="page-title">Countries & Sectors</h1>
          <p className="entity-workspace-subtitle">
            Aggregated organization footprint across investigations.
          </p>
        </div>
        <Link to="/organizations" className="btn btn-secondary btn-sm">View organizations</Link>
      </div>

      {loading ? (
        <p className="entity-workspace-empty">Loading aggregates...</p>
      ) : (
        <div className="dashboard-grid-two">
          <div className="card">
            <div className="card-header"><h3 className="card-title">By country</h3></div>
            <div className="card-body" style={{ padding: 0 }}>
              <table className="data-table">
                <thead><tr><th>Country</th><th>Organizations</th></tr></thead>
                <tbody>
                  {(aggregates?.countries || []).length === 0 ? (
                    <tr><td colSpan={2}>No country data yet.</td></tr>
                  ) : aggregates.countries.map((row) => (
                    <tr key={row.country}>
                      <td>{row.country}</td>
                      <td>{row.count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="card">
            <div className="card-header"><h3 className="card-title">By sector</h3></div>
            <div className="card-body" style={{ padding: 0 }}>
              <table className="data-table">
                <thead><tr><th>Sector</th><th>Organizations</th></tr></thead>
                <tbody>
                  {(aggregates?.sectors || []).length === 0 ? (
                    <tr><td colSpan={2}>No sector data yet.</td></tr>
                  ) : aggregates.sectors.map((row) => (
                    <tr key={row.sector}>
                      <td>{row.sector}</td>
                      <td>{row.count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Countries;
